export default "__VITE_ASSET__BmLjitq8__"